import React, { ComponentType } from 'react';
import LegalScreen from './components/LegalScreen';

const Legal: ComponentType = () => {
  return <LegalScreen page="legal.html" />;
};

export default Legal;
